<template>
  <header v-if="!kiosk" :class='{"onveil": searchActive, phone: size == "phone"}'>
    <section :class='{phone: size == "phone", bar: true}'>
      <router-link to='/' v-show='!searchActive'>
        <ListeningLabLogo />
      </router-link>
      <nav v-show='(!searchActive && size == "phone") ? active : (size != "phone" && !searchActive)  ' :class='{phone: size == "phone"}'>
        <router-link v-for='page in visible'
                     @click.native='active=false'
                     :to='urltopath(page.url)'
                     :key='page.uid'
                     v-html='page.strings.title' />
      </nav>
      <searchComponent  :style='{ "flex-grow" : (searchActive ? 3 : 0) }'
                        v-on='$listeners'
                        @toggleSearch='searchActive=!searchActive'
                        :results.sync='results'
                        :active='searchActive' />
      <hamburger class='hamburger' v-show='!searchActive && size == "phone"' :active.sync='active'/>
    </section>
    <searchResults v-show='results && searchActive' @resultClicked='resultClicked()' :results='results' />
  </header>
</template>


<script>
import mixins from './.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function() {
    return {
      searchActive: false,
      results: false,
      active: false
    }
  },
  methods: {
    resultClicked: function(){
      console.log('result is clicked');
      this.searchActive = false;
      this.results = false;
      this.$emit('removeReasonToShowVeil');
    }
  },
  computed: {
    visible: function() {
      let visibleIDs = Object.keys(this.kirby.pages);
      let visible = {};
      visibleIDs.map((id) => {
        if(this.kirby.pages[id].visible) visible[id] = this.kirby.pages[id];
      });
      return visible;
    }
  }
}

</script>

<style scoped>
  header {
    max-width: var(--main-max-width);
    background-color: var(--lightmint);
    padding: var(--main-padding);
    width: calc(100% - 2rem);
    z-index: 777;
    box-sizing: border-box;
    border-radius: 2rem;
    top: 1rem;
    margin: var(--main-nav-margin);
    position: fixed;
    left: 0;
    right: 0;
  }

  header.phone {
    border-radius: 4rem;
    box-shadow: 0em 0.25em 0.5em var(--transparentblue);
  }

  header.phone form {
    height: 3.5rem;
  }

  header.phone .hamburger {
    height: 3.5rem;
  }

  section.bar > a {
    flex-grow: 8;
    height: 2.5rem;
    width: 18rem;
  }

  section.phone.bar > a {
    width: 15rem;
    height: 2.33rem;
    padding: 0.4rem 0;
    overflow: hidden;
    display: block;
  }

  .hamburger {
    position: relative;
  }

  header section {
    font-size: 0.9em;
    justify-content: space-between;
    display: flex;
  }

  nav:not(.phone) {
    display: flex;
    flex-grow: 3;
    flex-direction: row;
    justify-content: space-around;
  }

  nav.phone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    background-color: var(--mint);
  }

  nav:not(.phone) a {
    margin-left: 2em;
    margin-top: 0.33em;
    height: 75%;
    position: relative;
  }

  nav.phone a {
    font-size: 2em;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1em;
    position: relative;
    display: inline-block;
    color: var(--blue);
    background-color: var(--lighblue);
  }

  nav:not(.phone) a::after {
    position: absolute;
    bottom: -0.25em;
    left: 0;
    content: '';
    background: var(--bluemint);
    height: 10%;
    width: 100%;
    transition: transform .4s ease;
    transform-origin: 100%;
    transform: scalex(1);
  }

  nav a:active::after {
    transform: scalex(1);
  }

  nav a:hover::after, nav a.router-link-active::after {
    transform: scalex(0);
  }

  form {
    flex-grow: 3;
  }

  header.onveil {
    z-index: 999;
    position: absolute;
  }
</style>
